export const FILTER_MAP_VENDEDOR = 'clientes/listarprospectos/filter-map-vendedor';
export const HIDE_POPUP_CLIENT = 'clientes/listarprospectos/hide-popup-client';
export const RECEIVE_DATA = 'clientes/listarprospectos/receive_data';
export const SET_MASK = 'clientes/listarprospectos/set-mask';
export const SET_ORDER = 'clientes/listarprospectos/set-order';
export const SET_SELECTED_ROW = 'clientes/listarprospectos/set-selected-row';
export const SHOW_POPUP_CLIENT = 'clientes/listarprospectos/show-popup-client';
export const UPDATE_FIELD_FILTER = 'clientes/listarprospectos/update-field-filter';
export const UPDATE_TABLE_COLUMN = 'clientes/listarprospectos/update-table-column';
export const   RECEIVE_OLAS_LIST = 'clientes/listarprospectos/receive_olas_list';